import {appRoute} from '../../../../app-route';
import {Meta} from '../../../../component/meta/meta';
import {PageHeaderTitle} from '../../../../component/page-header-title/page-header-title';
import {BreadCrumbs} from '../../../../layout/bread-crumbs/bread-crumbs';
import {Page} from '../../../../layout/page/page';
import {MainPageContainer} from '../../../../layout/page-card/main-page-card';
import {PageCard} from '../../../../layout/page-card/page-card';
import {PageHeader} from '../../../../layout/page-header/page-header';
import {Spinner} from '../../../../layout/spinner/spinner';
import {useLocale} from '../../../../provider/locale/locale-hook';
import {useUrl} from '../../../../util/url-hook/url-hook';

import {KnowledgeVideoActive} from './active-item/knowledge-video-active';
import {KnowledgeVideoItem} from './list-item/knowledge-video-item';
import {useKnowledgeVideos} from './use-knowledge-videos';
import * as styles from './knowledge-help-videos.scss';

export function KnowledgeHelpVideos(): JSX.Element {
    const {getLocalizedString} = useLocale();
    const {queries} = useUrl<{recommendationKey: string}>();

    const {recommendationVideoLinks, setActiveItemIndex, activeItemIndex, currentActiveItem} = useKnowledgeVideos(
        queries.recommendationKey
    );

    return (
        <Page
            isTopFilterHidden
            mainClassName={styles.KnowledgeHelpVideos}
            renderContainer={(children) => <MainPageContainer>{children}</MainPageContainer>}
        >
            <PageCard>
                <Meta title={getLocalizedString('CATEGORY_NAME__HELP__VIDEOS')} />
                <BreadCrumbs
                    list={[
                        {
                            path: appRoute.knowledge.path,
                            titleLangKey: 'CATEGORY_NAME__HELP',
                        },
                        {
                            path: appRoute.knowledgeHelpVideos.path,
                            titleLangKey: 'CATEGORY_NAME__HELP__VIDEOS',
                        },
                    ]}
                />
                <PageHeader>
                    <PageHeaderTitle title="CATEGORY_NAME__HELP__VIDEOS" />
                </PageHeader>
            </PageCard>

            <PageCard className={styles.KnowledgeHelpVideos_body}>
                <div className={styles.KnowledgeHelpVideos_content}>
                    <div>
                        {currentActiveItem ? (
                            <KnowledgeVideoActive
                                onNext={
                                    activeItemIndex !== recommendationVideoLinks.length - 1
                                        ? () => setActiveItemIndex(activeItemIndex + 1)
                                        : null
                                }
                                videoRecommendation={currentActiveItem}
                            />
                        ) : (
                            <Spinner />
                        )}
                    </div>

                    <div className={styles.KnowledgeHelpVideos_listContainer}>
                        <div className={styles.KnowledgeHelpVideos_list}>
                            {recommendationVideoLinks.map((recommendationVideoItem, index) => {
                                return (
                                    <KnowledgeVideoItem
                                        item={recommendationVideoItem}
                                        key={recommendationVideoItem.urlPattern}
                                        onClick={() => setActiveItemIndex(index)}
                                        selected={activeItemIndex === index}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </div>
            </PageCard>
        </Page>
    );
}
